import { render, staticRenderFns } from "./GoogleIcon.vue?vue&type=template&id=500f3384&scoped=true"
import script from "./GoogleIcon.vue?vue&type=script&lang=js"
export * from "./GoogleIcon.vue?vue&type=script&lang=js"
import style0 from "./GoogleIcon.vue?vue&type=style&index=0&id=500f3384&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500f3384",
  null
  
)

export default component.exports